import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Colors } from "../colors";
import SmallBox from "./SmallBox.jsx";
import { FaArrowRight } from "react-icons/fa";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";  // <-- Import useNavigate
import { denormalizeString, getCompanyDisplayName, localizeVar, forceLtrRange } from "../../util.jsx"
import { mobileWidth } from "../constants.jsx";
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { useCompanies } from "../../contexts/CompanyContext.jsx";
const MainTable = (props) => {
  const [salaries, setSalaries] = useState([]);
  const [role, setRole] = useState("");
  const { companyLogos, displayNamesByCompany } = useCompanies();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();  // <-- Initialize useNavigate

  useEffect(() => {
    getData(role);
  }, [role]);

  const getData = (selectedRole) => {
    // let url = `/api/v1/salary?limit=10&role=${selectedRole}`;
    let url = `/api/v1/salary?limit=8`
    fetch(url, { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
      })
      .then((data) => {
        setSalaries(JSON.parse(data.salaries));
      })
      .catch((error) => console.log(error));
  };

  return (
    <Wrapper>
      <TitleAndButton>
        <Title>{t("recent_submissions")}</Title>
        <FindOutLink href="/explore">
          {t("main_view_all")}
        </FindOutLink>
      </TitleAndButton>

      {/* <RoleSelector>
        <FormControl fullWidth>
          <InputLabel id="role-label">{t("main_role")}</InputLabel>
          <Select
            labelId="role-label"
            id="role-select"
            value={role}
            label="Role"
            onChange={(e) => setRole(e.target.value)}
          >
              {
                [
                  {role_key: "software engineer", role_en: "Software Engineer", role_ar: "مهندس برمجيات"},
                  {role_key: "product manager", role_en: "Product Manager", role_ar: "مدير المنتج"},
                  {role_key: "consultant", role_en: "Consultant", role_ar: "إستشاري"},
                  {role_key: "business analyst", role_en: "Business Analyst", role_ar: "محلل أعمال"},
                  {role_key: "data scientist", role_en: "Data Scientist", role_ar: "عالم البيانات"},
                ].map((item) => {
                  const currLang = i18n.resolvedLanguage;
                  const roleName = currLang == "en" ? item.role_en : item.role_ar;
                  return ((
                    <MenuItem value={item.role_key}>{roleName}</MenuItem>
                  ))
                })
              }
          </Select>
        </FormControl>
      </RoleSelector> */}
      <FlexGrid>
        {
          (salaries.length > 0) && (
            salaries.map((item) => {
              const currLang = i18n.resolvedLanguage;
  
              return ((
                <SmallBox
                  key={item.id}
                  companyName={getCompanyDisplayName(item, currLang, displayNamesByCompany)}
                  companyNameNormalized={item.company_name_en}
                  roleName={denormalizeString(localizeVar(item, "role", currLang))}
                  salary={`${item.salary_per_month.toLocaleString()}`}
                  logo={companyLogos[item.company_name_en] || ""}
                  createdAt={item.created_at}
                  locationCity={denormalizeString(localizeVar(item, "location_city", currLang))}
                  exp = {`${forceLtrRange(item.experience_in_yrs,currLang)} ${t("card_exp")}`}
                />
              ))
            })
          )
        }
        </FlexGrid>
        {salaries.length == 0 && 
            <Alert icon={<ShareIcon />} severity="info">
              <AlertTitle>{t("main_no_salaries")}</AlertTitle>
              {t("main_no_salaries_details")}{' '}
              <FindOutLink style={{display:"inline"}} href="/addsalary">{t("main_no_salaries_link")}</FindOutLink> {t("main_no_salaries_details_part_2")}
            </Alert>
        }
      
    </Wrapper>
  );
};

export default MainTable;

const Wrapper = styled.div`
  width : 80vw;
  // width: 40vw;
  @media (max-width: ${mobileWidth}){
  width:80vw;
  align-self:center;
  }
`;
const FlexGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));
  justify-content:center;
  gap:24px;
  width:100%;
`
const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 50px;
  margin-bottom: 30px;
`;

const TitleAndButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Title = styled.h2`
  color: ${Colors.black};
  font-size: 24px;
`;

const RoleSelector = styled.div`
  margin-bottom: 10px;
`;

const RightAligned = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
`;

const FindOutLink = styled.a`
  color: #0395ff;
  text-decoration: none;
  font-weight: 300;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #0458a2;
  }
`;

const ArrowIcon = styled(FaArrowRight)`
  margin-left: 5px;
  vertical-align: middle;
`;
